var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIonic(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 50 50",
    style: {
      enableBackground: "new 0 0 50 50"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#4E8EF7;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M45.1,8.3c0,0.9-0.3,1.6-0.8,2.2c3.1,4.1,4.9,9.1,4.9,14.6c0,13.4-10.9,24.2-24.2,24.2S0.8,38.4,0.8,25 C0.8,11.7,11.6,0.8,25,0.8c5.5,0,10.5,1.8,14.6,4.9c0.6-0.5,1.4-0.8,2.2-0.8C43.6,4.9,45.1,6.4,45.1,8.3z M25,48.4 c12.9,0,23.4-10.5,23.4-23.4c0-5.2-1.7-10.1-4.7-14c-0.6,0.4-1.2,0.6-2,0.6c-1.9,0-3.4-1.5-3.4-3.4c0-0.7,0.2-1.4,0.6-2 c-3.9-2.9-8.8-4.7-14-4.7C12.1,1.6,1.6,12.1,1.6,25S12.1,48.4,25,48.4z M25,34.9c-5.5,0-9.9-4.4-9.9-9.9s4.4-9.9,9.9-9.9 s9.9,4.4,9.9,9.9S30.4,34.9,25,34.9z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIonic);
export default __webpack_public_path__ + "static/media/ionic.6cb135d6457b1e7daab2c30915db5449.svg";
export { ForwardRef as ReactComponent };